<template>
  <footer class="p-25px bg-black text-white text-sm flex justify-between">
    <div>{{ $t("global.footer.copyright") }}</div>
    <div>v{{ version }}</div>
    <div class="flex">
      <div class="px-2">
        <TextLink
          to="/changelog"
          :name="$t('global.footer.linkChangeLog')"
          :white="true"
        ></TextLink>
      </div>
      <div class="px-2">
        <TextLink
          to="/eula-privacy-policy?static=true"
          :name="$t('global.footer.linkEULAPrivacyPolicy')"
          :white="true"
        ></TextLink>
      </div>
    </div>
  </footer>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import TextLink from "@/components/utils/TextLink.vue";

@Options({
  data() {
    return {
      version: process.env.VUE_APP_VERSION,
    };
  },
  components: {
    TextLink,
  },
})
export default class Footer extends Vue {}
</script>
